export default __webpack_public_path__ + "static/media/policy.90ec6186.svg";